<div class="sidebar-root">
  @if (homePath(); as home) {
    <a class="sidebar-brand" [routerLink]="['/', home]" (click)="onNavigate()">
      <img class="brand-logo" [ngSrc]="'/cashalog_logo.png'" width="28" height="28" alt="Cashalog" />
      <span class="brand-text">
        <span class="brand-name">CASHALOG </span>
      </span>
    </a>
  } @else {
    <div class="sidebar-brand">
      <img class="brand-logo" [ngSrc]="'/cashalog_logo.png'" width="28" height="28" alt="Cashalog" />
      <span class="brand-text">
        <span class="brand-name">CASHALOG </span>
      </span>
    </div>
  }

  <nav class="sidebar-nav" [attr.aria-label]="'sidebar.nav.ariaLabel' | translate">
    @if (status() === 'loading' && navLinks().length === 0) {
      <p class="sidebar-status" role="status">{{ 'sidebar.loading' | translate }}</p>
    } @else if (status() === 'error' && navLinks().length === 0) {
      <p class="sidebar-status" role="alert">{{ loadError() || ('sidebar.loadError' | translate) }}</p>
      <button type="button" class="sidebar-retry" (click)="retryLoad()">
        {{ 'sidebar.retry' | translate }}
      </button>
    } @else if (status() === 'ready' && navLinks().length === 0) {
      <p class="sidebar-status">{{ 'sidebar.empty' | translate }}</p>
    }

    @for (link of navLinks(); track link.key) {
      <a
        class="nav-link"
        [routerLink]="['/', link.path]"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: link.exact }"
        (click)="onNavigate()"
      >
        @if (link.icon) {
          <i class="nav-icon" [class]="link.icon" aria-hidden="true"></i>
        }
        <span class="nav-label">{{ link.labelKey | translate }}</span>
        @if (link.badgeCount && link.badgeCount() > 0) {
          <span
            class="nav-badge"
            [attr.aria-label]="(link.badgeAriaLabelKey ?? 'sidebar.badges.pendingCount') | translate"
            >{{ link.badgeCount() }}</span
          >
        }
      </a>
    }

    <!-- @if (showModuleNamesLink()) {
      <a
        class="nav-link"
        [routerLink]="['/', paths.moduleNames]"
        routerLinkActive="active"
        (click)="onNavigate()"
      >
        <i class="nav-icon pi pi-pencil" aria-hidden="true"></i>
        <span class="nav-label">{{ 'moduleNamesPage.title' | translate }}</span>
      </a>
    } -->
  </nav>

  <div class="sidebar-spacer" aria-hidden="true"></div>

  <section class="sidebar-user" [attr.aria-label]="'sidebar.user.ariaLabel' | translate">
    <div
      class="user-card"
      [attr.role]="profileEnabled() ? 'link' : null"
      [attr.tabindex]="profileEnabled() ? 0 : null"
      [attr.aria-label]="profileEnabled() ? ('sidebar.links.profile' | translate) : null"
      (click)="onProfileClick()"
      (keydown.enter)="onProfileClick()"
      (keydown.space)="onProfileClick()"
    >
      <div class="user-avatar" aria-hidden="true">
        @if (userLogo(); as logo) {
          <img class="user-avatar-image" [src]="logo" width="36" height="36" alt="" />
        } @else {
          {{ userInitials() }}
        }
      </div>
      <div class="user-meta">
        <div class="user-name">{{ userName() || ('sidebar.user.defaultName' | translate) }}</div>
        @if (userRole()) {
          <div class="user-role">{{ userRole() }}</div>
        }
      </div>
    </div>

    <button
      type="button"
      class="logout-btn"
      [class.loading]="isLoggingOut()"
      [disabled]="isLoggingOut()"
      [attr.aria-busy]="isLoggingOut()"
      (click)="onLogout()"
    >
      <i [class]="isLoggingOut() ? 'pi pi-spinner pi-spin' : 'pi pi-sign-out'" aria-hidden="true"></i>
      <span>{{ isLoggingOut() ? ('sidebar.actions.loggingOut' | translate) : ('sidebar.actions.logout' | translate) }}</span>
    </button>
  </section>
</div>
